import { DefectDto } from './defectDto';

export class AggregatedDefectDto extends DefectDto {
  public defects?: DefectDto[];
  public detailsCollapsed: boolean = false;
}
